import {
  getLabelTagsArray,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import { goalsOptions } from "../../Options/goalsOptions";
import goalsIcon from "../../../../assets/doctorIcons/goals.svg";

const NutritionistGoalsSummary = ({ formData }) => {
  const constructGoalsSummaryItems = () => {
    const goalsSummaryItems = [];
    const pushGoalsItem = (key, label, children) => {
      goalsSummaryItems.push({ key, label, children });
    };
    const goals = formData?.goals || {};
    if (goals?.goals) {
      pushGoalsItem(
        "1",
        "Goals",
        <>
          {getLabelTagsArray(goalsOptions, goals?.goals)}
          {getLabelTagsWithDynamicInputs(goals?.others)}
        </>
      );
    }
    return goalsSummaryItems;
  };
  const goalsSummaryItems = constructGoalsSummaryItems();
  return (
    <SummaryWrapper
      items={goalsSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={goalsIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Goals
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default NutritionistGoalsSummary;
